import React from "react";
import { Card, Badge, Button, Tournament } from ".";

export const TournamentCard: React.FC<{ t: Tournament; onOpen: (id: string) => void }>= ({ t, onOpen }) => (
  <Card>
    <div className="u-row u-gap-12" style={{ justifyContent: "space-between" }}>
      <div>
        <div className="card__header">{t.name}</div>
        <div className="card__meta">{new Date(t.date).toLocaleDateString()}</div>
      </div>
      <Badge kind="info">NYC</Badge>
    </div>
    <div style={{ marginTop: 10 }}>
      <Button onClick={() => onOpen(t.id)}>View bracket</Button>
    </div>
  </Card>
);

export default TournamentCard;


